export default __webpack_public_path__ + "static/media/hip-pop.107e9fd1.jpeg";